/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { persistReducer } from 'redux-persist';
import { combineReducers } from 'redux';

import sessionStorage from 'redux-persist/lib/storage/session'; // defaults to localStorage for web and AsyncStorage for react-native
import storage from 'redux-persist/lib/storage';
import cart from './ducks/Cart/Cart-Reducer';
import common from './ducks/Common/Common-Reducers';
import order from './ducks/Order/Order-Reducer';
import paymentReducers from './ducks/Payment';
import recipientReducers from './ducks/Recipient';

const paymentReducerPersistConfig = {
    key: 'payment',
    storage: sessionStorage,
    whitelist: ['paypal', 'billingAddressForm', 'passport'],
};

const recipientReducerPersistConfig = {
    key: 'recipient',
    storage: sessionStorage,
    whitelist: ['orderItems'],
};

const paymentPersistReducer = persistReducer(paymentReducerPersistConfig, paymentReducers);
const recipientPersistReducer = persistReducer(recipientReducerPersistConfig, recipientReducers);

const checkoutReducers = combineReducers({
    cart,
    common,
    order,
    payment: paymentPersistReducer,
    recipient: recipientPersistReducer,
});

const checkoutPersistConfig = {
    key: 'checkout',
    storage,
    whitelist: ['order', 'common'],
};

export default persistReducer(checkoutPersistConfig, checkoutReducers);
